module.exports = __webpack_public_path__ + "media/images/favicons/icon-96x96-89564ab3a0dfe89bc97d90bf33a3594b.png";